import styled from 'styled-components';

export const BannerWrapper = styled.div`
  position: relative;
  background: radial-gradient(220px at 25% 20%, rgba(216, 243, 230, 0.4) 0%, transparent 80%),
    radial-gradient(220px at 75% 25%, rgba(255, 248, 231, 0.5) 0%, transparent 80%),
    radial-gradient(220px at 25% 85%, rgba(212, 217, 252, 0.45) 0%, transparent 80%),
    radial-gradient(220px at 80% 90%, rgba(230, 150, 127, 0.25) 0%, transparent 80%);

  padding: 24px 24px 0 24px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    background: radial-gradient(
        500px at 20% 30%,
        rgba(216, 243, 230, 0.8) 0%,
        rgba(216, 243, 230, 0.6) 60%,
        transparent 100%
      ),
      radial-gradient(
        500px at 80% 25%,
        rgba(255, 248, 231, 0.85) 0%,
        rgba(255, 248, 231, 0.7) 60%,
        transparent 100%
      ),
      radial-gradient(
        500px at 20% 80%,
        rgba(212, 217, 252, 0.8) 0%,
        rgba(212, 217, 252, 0.6) 60%,
        transparent 100%
      ),
      radial-gradient(
        500px at 85% 85%,
        rgba(230, 150, 127, 0.35) 0%,
        rgba(230, 150, 127, 0.25) 60%,
        transparent 100%
      );
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  border: none;
  background: transparent;
  box-shadow: none;
  cursor: pointer;
  opacity: 0.6;
`;
